
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import SmashableMarkerVine from "../../editor/entity-markers/SmashableMarkerVine";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import CheckpointMarker from "../../editor/CheckpointMarker";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PositionMarker from "../../editor/PositionMarker";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import MoverData from "../../../components/platformer/MoverData";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkHard2 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 5951, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 3289, 906);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -86, 806);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 1145, 764);
    this.add(trunk_png);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 3286, 602);
    this.add(platformMarkerFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 5486, 538);
    this.add(platformMarkerFoliage_2);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1571, 519);
    this.add(gemMarker_11);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 1859, 571);
    this.add(megaGemMarker_2);

    // smashableMarkerVine
    const smashableMarkerVine = new SmashableMarkerVine(scene, 1764, 453);
    this.add(smashableMarkerVine);

    // platformMarkerFoliage4
    const platformMarkerFoliage4 = new PlatformMarkerFoliage4(scene, 1679, 659);
    this.add(platformMarkerFoliage4);

    // platformFoliage1
    const platformFoliage1 = new PlatformFoliage1(scene, 1780, 305);
    this.add(platformFoliage1);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 1683, 968);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 5474, 841);
    this.add(trunk_png_5);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 2377, 208);
    this.add(platformMarkerFoliage_3);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 5478, 436);
    this.add(gemMarker_1);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 1777, 222);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 1164, 332);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 3132, 89);
    this.add(gemMarker_5);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 2378, 79);
    this.add(gemMarker_6);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3385, 523);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 4712, 460);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 4700, 764);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4704, 358);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, -68, 496);
    this.add(platformMarkerFoliage_6);

    // smashableMarkerVine_1
    const smashableMarkerVine_1 = new SmashableMarkerVine(scene, 3304, 394);
    this.add(smashableMarkerVine_1);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage4(scene, 3293, 229);
    this.add(platformMarkerFoliage);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 4166, 471);
    this.add(megaGemMarker_1);

    // smashableMarkerVine_2
    const smashableMarkerVine_2 = new SmashableMarkerVine(scene, 4071, 353);
    this.add(smashableMarkerVine_2);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage4(scene, 3986, 559);
    this.add(platformMarkerFoliage_7);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 3990, 868);
    this.add(trunk_png_9);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 4084, 122);
    this.add(gemMarker_9);

    // platformMarkerFoliage_8
    const platformMarkerFoliage_8 = new PlatformMarkerFoliage3(scene, 4045, 203);
    this.add(platformMarkerFoliage_8);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -225, 431);
    this.add(checkpointMarker);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 4594, 417);
    this.add(checkpointMarker_2);

    // platformFoliage_1
    const platformFoliage_1 = new PlatformFoliage1(scene, 3081, 227);
    this.add(platformFoliage_1);

    // trapMarkerSpikes
    const trapMarkerSpikes = new TrapMarkerSpikes(scene, 3311, 163);
    this.add(trapMarkerSpikes);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 2861, 888);
    this.add(trunk_png_3);

    // platformFoliage_3
    const platformFoliage_3 = new PlatformFoliage1(scene, 2864, 577);
    this.add(platformFoliage_3);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 2876, 481);
    this.add(gemMarker_2);

    // trapMarkerSpikes_1
    const trapMarkerSpikes_1 = new TrapMarkerSpikes(scene, 2178, 132);
    this.add(trapMarkerSpikes_1);

    // platformMarkerFoliage_4
    const platformMarkerFoliage_4 = new PlatformMarkerFoliage3(scene, 1111, 447);
    this.add(platformMarkerFoliage_4);

    // trapMarkerSpikes_3
    const trapMarkerSpikes_3 = new TrapMarkerSpikes(scene, 1016, 402);
    this.add(trapMarkerSpikes_3);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2373, 596);
    this.add(gemMarker_8);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2209, 666);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2548, 669);
    this.add(positionMarker_1);

    // platformMarkerJungleLog
    const platformMarkerJungleLog = new PlatformMarkerJungleLog(scene, 2214, 666);
    this.add(platformMarkerJungleLog);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 2465, 594);
    this.add(gemMarker_10);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 2282, 594);
    this.add(gemMarker_12);

    // trunk_png_13
    const trunk_png_13 = new DecorationTrunk(scene, 576, 750);
    this.add(trunk_png_13);

    // platformFoliage_5
    const platformFoliage_5 = new PlatformFoliage2(scene, 580, 445);
    this.add(platformFoliage_5);

    // trunk_png_14
    const trunk_png_14 = new DecorationTrunk(scene, 829, 686);
    this.add(trunk_png_14);

    // platformFoliage_6
    const platformFoliage_6 = new PlatformFoliage1(scene, 837, 381);
    this.add(platformFoliage_6);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 582, 349);
    this.add(gemMarker_14);

    // trapSpikesMarker_2
    const trapSpikesMarker_2 = new TrapMarkerSpikes(scene, 843, 329);
    this.add(trapSpikesMarker_2);

    // trunk_png_15
    const trunk_png_15 = new DecorationTrunk(scene, 5137, 770);
    this.add(trunk_png_15);

    // platformFoliage_7
    const platformFoliage_7 = new PlatformFoliage1(scene, 5145, 465);
    this.add(platformFoliage_7);

    // trapSpikesMarker_3
    const trapSpikesMarker_3 = new TrapMarkerSpikes(scene, 5151, 413);
    this.add(trapSpikesMarker_3);

    // this (components)
    new ChunkBoundaries(this);

    // smashableMarkerVine (components)
    const smashableMarkerVineSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine);
    smashableMarkerVineSimpleBreakableBlocker.allowedCharacter = "ice";

    // smashableMarkerVine_1 (components)
    const smashableMarkerVine_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_1);
    smashableMarkerVine_1SimpleBreakableBlocker.allowedCharacter = "panda";

    // smashableMarkerVine_2 (components)
    const smashableMarkerVine_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(smashableMarkerVine_2);
    smashableMarkerVine_2SimpleBreakableBlocker.allowedCharacter = "grizz";

    // platformMarkerJungleLog (components)
    const platformMarkerJungleLogMoverData = new MoverData(platformMarkerJungleLog);
    platformMarkerJungleLogMoverData.startMarker = positionMarker;
    platformMarkerJungleLogMoverData.endMarker = positionMarker_1;
    platformMarkerJungleLogMoverData.startWait = 500;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
